module.exports = __webpack_public_path__ + "static/anchorage-05483611bf184ada1c191243016b4f42.png";